module.exports = __webpack_public_path__ + "assets/img/5@3x.4ee9ad87.png";